var _this = this;
import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import updateBrandsSubscriptions from '../mutators/updateBrandsSubscriptions';
import getBrandsSubscriptionsService from '../services/getBrandsSubscriptionsService';
import { action, orchestrator } from 'satcheljs';
var loadBrandsSubscriptions = action('loadBrandsSubscriptions', function () { return ({
    datapointConfig: {
        name: datapoints.LoadBrandsSubscriptions.datapoint.name,
    },
}); });
export default loadBrandsSubscriptions;
orchestrator(loadBrandsSubscriptions, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getBrandsSubscriptionsService()];
            case 1:
                response = _a.sent();
                updateBrandsSubscriptions(response);
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=loadBrandsSubscriptions.js.map